import { v4 as uuidV4 } from 'uuid';

import {
  CohortBuilderItemChangeStatusLegacy,
  IndexDateTypeLegacy,
  type IndexDateVariableLegacy,
} from '@verantos-dev/types-cohorts';
import { Cohort_definitionContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

export const generateIndexDateFromDSL = (
  cohortDefinitionTree: Cohort_definitionContext
): IndexDateVariableLegacy | undefined => {
  if (!cohortDefinitionTree.index_date()) return undefined;

  try {
    const indexDateDefinition = cohortDefinitionTree?.index_date()?.index_date_definition();
    const indexDateType = indexDateDefinition?.calendar_date()?.getText()
      ? IndexDateTypeLegacy.CALENDAR
      : IndexDateTypeLegacy.EVENT;

    let indexDateValue = '';
    let indexDateRangeValue;
    if (indexDateDefinition?.index_event_date()) {
      indexDateValue =
        indexDateDefinition?.index_event_date()?.INSTANCE_EVENT_NAME()?.getText() || '';
      if (indexDateDefinition?.index_event_date()?.index_date_bounds()) {
        const startDate =
          indexDateDefinition
            ?.index_event_date()
            ?.index_date_bounds()
            ?.lower_date_bounds()
            ?.DATE()
            ?.getText() || '';
        const endDate =
          indexDateDefinition
            ?.index_event_date()
            ?.index_date_bounds()
            ?.upper_date_bounds()
            ?.DATE()
            ?.getText() || '';
        indexDateRangeValue = {
          startDate: startDate,
          endDate: endDate,
        };
      }
    }

    if (indexDateDefinition?.calendar_date()) {
      indexDateValue = indexDateDefinition?.calendar_date()?.DATE()?.getText() || '';
    }

    return {
      id: uuidV4(),
      type: indexDateType,
      indexDateValue: indexDateValue,
      indexDateRangeValue,
      changeStatus: 'NEW' as CohortBuilderItemChangeStatusLegacy,
    };
  } catch (error) {
    console.error('Error fetching index date', error);
    return undefined;
  }
};
